'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function createStat(_ref) {
  var network = _ref.network;

  function stat() {
    return _stat.apply(this, arguments);
  }

  function _stat() {
    _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          bitswap,
          snapshot,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return network.use(options);

            case 3:
              bitswap = _context.sent.bitswap;
              snapshot = bitswap.stat().snapshot;
              return _context.abrupt("return", {
                provideBufLen: parseInt(snapshot.providesBufferLength.toString()),
                blocksReceived: BigInt(snapshot.blocksReceived.toString()),
                wantlist: Array.from(bitswap.getWantlist()).map(function (e) {
                  return e[1].cid;
                }),
                peers: bitswap.peers().map(function (id) {
                  return id.toB58String();
                }),
                dupBlksReceived: BigInt(snapshot.dupBlksReceived.toString()),
                dupDataReceived: BigInt(snapshot.dupDataReceived.toString()),
                dataReceived: BigInt(snapshot.dataReceived.toString()),
                blocksSent: BigInt(snapshot.blocksSent.toString()),
                dataSent: BigInt(snapshot.dataSent.toString())
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _stat.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(stat);
}

exports.createStat = createStat;